// Gatsby wywołuje tę funkcję po stronie PRZEGLĄDARKI
import React from 'react';
import { I18nProvider } from './src/i18n/I18nProvider';

export const wrapRootElement = ({ element }) => (
  <I18nProvider>{element}</I18nProvider>
);
